import { render, staticRenderFns } from "./ChoosePlan.vue?vue&type=template&id=3ee8fbd9&scoped=true&"
import script from "./ChoosePlan.vue?vue&type=script&lang=js&"
export * from "./ChoosePlan.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePlan.vue?vue&type=style&index=0&id=3ee8fbd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee8fbd9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VProgressCircular,VRow})
